import { render, staticRenderFns } from "./GalleryImageCard.vue?vue&type=template&id=40e49a34"
import script from "./GalleryImageCard.vue?vue&type=script&lang=js"
export * from "./GalleryImageCard.vue?vue&type=script&lang=js"
import style0 from "./GalleryImageCard.vue?vue&type=style&index=0&id=40e49a34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports